import { RenderedRowParams, formatter } from '@qrios/frontend-library';

import Cost from '../../../cost';
import { OPERATION_STATUS } from '../../../status';

export const renderCost = (params: RenderedRowParams) => (
  <Cost value={formatter.amountFormatter(params)} operationStatus={params.row.status as OPERATION_STATUS} />
);
